// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--cf66e";
export var headingContainer = "index-module--heading-container--89468";
export var highlight = "index-module--highlight--b24df";
export var highlightLine = "index-module--highlight-line--d4b58";
export var image1 = "index-module--image-1--aa3e9";
export var image2 = "index-module--image-2--ddce4";
export var imageContainer = "index-module--image-container--71ad0";